import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { OrderModel } from 'src/app/store/order/model';
import { DxTextAreaComponent } from 'devextreme-angular';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderFacade } from 'src/app/store/order/facade';
import { AbstractOrderUIService } from 'src/app/core/services/abstract/abstract-order-ui-service';
import { OrderConstants } from 'src/app/core/constants/order-constants';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-dialog-change-order-status',
  templateUrl: './dialog-change-order-status.component.html',
  styleUrls: ['./dialog-change-order-status.component.scss'],
  standalone: false,
})
export class DialogChangeOrderStatusComponent implements OnInit {
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);
  private orderUIService = inject(AbstractOrderUIService);

  @ViewChild('textAreaComponent', { read: DxTextAreaComponent, static: false }) textAreaComponent;

  private eventChange$: Observable<boolean>;
  private _observer: Observer<boolean>;
  showDialog: boolean = false;
  title: string;
  order: OrderModel;
  notes: string;
  mark: number;
  files: any[] = [];
  newStatusId: number;
  evaluationView: boolean;
  rateCommentTitle: string;
  rateComment: string;

  constructor() {
    this.eventChange$ = new Observable<boolean>(observer => (this._observer = observer));
  }

  ngOnInit() {}

  execute(order: OrderModel, newStatusId: number, externalRate: number): Observable<boolean> {
    var that = this;
    setTimeout(function () {
      that.textAreaComponent.instance.focus();
    }, 100);

    this.translate.get('CHANGE_STATUS').subscribe(value => {
      this.title = value;
    });

    this.translate.get('EVALUATION_DEFAULT_COMMENT_TITLE').subscribe(value => {
      this.rateCommentTitle = value;
    });
    this.translate.get('EVALUATION_DEFAULT_COMMENT').subscribe(value => {
      this.rateComment = value;
    });

    this.newStatusId = newStatusId;
    this.order = order;
    this.files = [];
    this.mark = order.mark;
    this.notes = '';
    this.showDialog = true;

    if (this.isConfirmed(newStatusId)) {
      this.evaluationView = true;

      this.translate.get('EFFICIENCY_MARK').subscribe(value => {
        this.title = value;
      });

      // External (from email by URL) evaluation
      if (OrderConstants.AllowedValuesOfEvaluation.includes(externalRate)) {
        this.mark = externalRate;

        this.rateCommentTitle = this.getRateCommentTitle(externalRate);
        this.rateComment = this.getRateComment(externalRate);
      }
    }

    if (this.isRequiresImprovement(newStatusId)) {
      this.translate.get('REQUIRES_IMPROVEMENT').subscribe(value => {
        this.title = value;
      });
    }

    return this.eventChange$;
  }

  onConfirm() {
    if (this.isConfirmed(this.newStatusId) && !this.mark) {
      this.translate.get('EVALUATION_NO_RATE_ERROR').subscribe(value => {
        notify({ message: value, width: 600 }, 'error', 3000);
      });

      return;
    }

    if (this.orderUIService.validateFiles(this.files) === true) {
      this._observer.next(true);
      this.showDialog = false;

      this.orderFacade.saveStatus(this.order.id, this.mark, this.notes, this.files, this.newStatusId, true);
    }
  }

  onCancel() {
    this._observer.next(false);
    this.showDialog = false;
  }

  isCompleted(statusId: number) {
    return OrderStatusConstants.isCompleted(statusId);
  }

  isConfirmed(statusId: number) {
    return OrderStatusConstants.isConfirmed(statusId);
  }

  isRequiresImprovement(statusId: number) {
    return OrderStatusConstants.isRequiresImprovement(statusId);
  }

  onClickMark(valueMark: number) {
    this.mark = valueMark;

    this.rateCommentTitle = this.getRateCommentTitle(valueMark);
    this.rateComment = this.getRateComment(valueMark);
  }

  getMaxFileSize(): number {
    return OrderConstants.MaxFileSize;
  }

  getSupportedFileFormat(): string[] {
    return OrderConstants.SupportedFileFormat;
  }

  private getRateCommentTitle(rateValue: number): string {
    let titlesName: string[] = [
      'EVALUATION_BAD_RATE_COMMENT_TITLE',
      'EVALUATION_NORMAL_RATE_COMMENT_TITLE',
      'EVALUATION_GOOD_RATE_COMMENT_TITLE',
    ];
    return this.getRateHint(rateValue, titlesName);
  }

  private getRateComment(rateValue: number): string {
    let commentsName: string[] = ['EVALUATION_BAD_RATE_COMMENT', 'EVALUATION_NORMAL_RATE_COMMENT', 'EVALUATION_GOOD_RATE_COMMENT'];
    return this.getRateHint(rateValue, commentsName);
  }

  private getRateHint(rateValue: number, hintsName: string[]): string {
    let hintValue: string;

    // Evaluation value is not allowed
    if (!OrderConstants.AllowedValuesOfEvaluation.includes(rateValue)) {
      return hintValue;
    }

    let rateValueIndex = OrderConstants.AllowedValuesOfEvaluation.indexOf(rateValue);

    // There is no hint for this value
    if (rateValueIndex >= hintsName.length) {
      return hintValue;
    }

    this.translate.get(hintsName[rateValueIndex]).subscribe(value => {
      hintValue = value;
    });

    return hintValue;
  }
}
